var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex flex-column align-center text-center gr-4" },
    [
      _c(
        "a",
        {
          staticClass: "d-inline-flex",
          attrs: {
            href: _setup.reverseFull({
              name: "lpu",
              args: [_vm.lpu.town.translit, _vm.lpu.translit],
            }),
          },
        },
        [
          _setup.ff_update_lpu_logo
            ? _c(_setup.LpuLogoPicture, {
                attrs: {
                  "img-class": "object-fit-scale-down rounded",
                  contain: "",
                  width: "240",
                  height: "80",
                  files: _setup.getLpuLogoImageFiles(_vm.lpu),
                  alt: _setup.t("Аватар", _setup.options),
                },
              })
            : _c("img", {
                staticClass: "object-fit-scale-down rounded",
                attrs: {
                  alt: _setup.t("Аватар", _setup.options),
                  src: _setup.getLpuAvatarUrl({ lpu: _vm.lpu }),
                  width: "240",
                  height: "80",
                },
              }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column justify-center" }, [
        _c(
          "a",
          {
            staticClass:
              "text-subtitle-1 text-decoration-none primary--text mb-1",
            attrs: {
              href: _setup.reverseFull({
                name: "lpu",
                args: [_vm.lpu.town.translit, _vm.lpu.translit],
              }),
            },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _setup.transDynamic(
                    _vm.lpu,
                    `name,${_setup.languageIso},${_setup.needTranslate}`
                  )
                ) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "text-body-2" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _setup.transDynamic(
                  _vm.lpu.town,
                  `name,${_setup.languageIso},${_setup.needTranslate}`
                )
              ) +
              "\n    "
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }